function noop() {}

export { noop as isatty, noop as setRawMode };
